import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface IOrderDetail {
    id?: string,
    prefix?: string,
    shopId?: string,
    shopCode?: string,
    shopName?: string,
    branch?: string,
    ver?: string,
    enable?: string,
    orgCode?: string,
    orgName?: string,
    contact?: string,
    phone?: string,
    address?: string,
    status?: number | boolean,
    sourceApp?: string,
    categoryName?:string,
    typeCode?:string,
    typeName?:string,
    suffixNum?: number,
    settingType? : string,
    isYear?: number,
    isMonth?: number,
    isDate?: number,
    style? : string,
    note? : string,
    orderNum?: number,
    traceId?: string,
    deleteFlag?: number,
    createTime? : string,
    updateTime? : string,
    createUser? : string,
    updateUser? : string,
    [key: string]: any
}
//新增
export interface IOrderInsert {
    "prefix"?:string,   // "ad reprehenderit magna in",
    "suffixNum"?:number,   // 22,
    "settingType"?:string,   // "CALCULATE",
    "isYear"?:number,   // 55,
    "isMonth"?:number,   // 59,
    "isDate"?:number,   // 20180911,
    "note"?:string,   // "veniam sint laborum tempor",
    "style"?:string,   // "incididunt"
}

//编辑
export interface IOrderUpdate extends IOrderInsert {
    id?: string,
}
//搜索条件
export interface IOrderSearchFields {
    startTime?:string
    endTime?:string
    companyName?:string
    fleetName?:string
    customerVehicleCode?:string
    vehicleSite?:string
    [key:string]:any
}

export interface IOrderSearch
    extends IOrderSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch
    extends IOrderSearchFields, ISearchPage {
}



class OrderService {
    async page(searchVo: IOrderSearch, config: object = {}) {
        const apiUrl = "/threeInspection/ciOrder/staticSummary";
        return await httpRequest.post<any>(apiUrl, searchVo, config);
    }    
    async one(searchVo: IOrderSearchFields) {
        const apiUrl = "/threeInspection/ciOrder/page";
        return await httpRequest.post<IPage<IOrderDetail>>(apiUrl, searchVo);
    }    
    async orderLogs(searchVo: IOrderSearchFields) {
        const apiUrl = "/threeInspection/ciOrder/progress_log/list";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }    
    async getOrderImg(updateVo: IOrderUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getImageClassifyList(updateVo: IOrderUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    async getDetialOne(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/order/details/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }
    async printDetial(searchVo: IOrderUpdate) {
        const apiUrl = "/threeInspection/ciOrder/pageDetails";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }
}

export const orderService = new OrderService();
